import React from 'react'

import {
  EndIcon,
  ErrorMessage,
  InputContainer,
  InputWrapper,
  StartIcon,
  StyledInput,
  Label,
} from './styles'
import { InputProps } from './types'

export const Input: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<InputProps> & React.RefAttributes<HTMLInputElement>
> = React.forwardRef(
  (
    {
      className,
      type,
      value,
      placeholder,
      maxLength,
      min,
      max,
      startIcon,
      endIcon,
      error,
      showError,
      onChange,
      onFocus,
      onBlur,
      fullWidth,
      disabled,
      view,
      label,
      autoFocus,
    }: InputProps,
    ref
  ) => (
    <InputContainer fullWidth={fullWidth} className={className}>
      {label && <Label>{label}</Label>}
      <InputWrapper>
        <StyledInput
          ref={ref}
          type={type || 'text'}
          min={min}
          max={max}
          value={value}
          placeholder={placeholder}
          maxLength={maxLength}
          error={error}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          startIcon={startIcon}
          endIcon={endIcon}
          disabled={disabled}
          view={view}
          autoFocus={autoFocus}
        />
        {startIcon && <StartIcon icon={startIcon} />}
        {endIcon && <EndIcon icon={endIcon} />}
      </InputWrapper>
      {showError && (
        <ErrorMessage visible={Boolean(error)}>{error}</ErrorMessage>
      )}
    </InputContainer>
  )
)

export default Input
